import React from "react";
import { useGame, usePlayer } from "../hooks";
{
    /*
    <Steps steps=[Introduction, Challenge]>
      <Game></Game>
  
    </Steps>
  */
}
export const Steps = ({ steps, progressKey, doneKey, object, children, }) => {
    let obj;
    const player = usePlayer();
    const game = useGame();
    if (object) {
        obj = object;
    }
    else {
        if (!player) {
            return React.createElement(React.Fragment, null);
        }
        obj = player;
    }
    if (obj.get(doneKey)) {
        return React.createElement(React.Fragment, null, children);
    }
    let actualSteps;
    if (typeof steps === "function") {
        if (!game) {
            console.warn("steps: cannot use steps function if game not assigned");
            return React.createElement(React.Fragment, null);
        }
        const res = steps(game?.treatment || {});
        if (!res) {
            obj.set(doneKey, true);
            return React.createElement(React.Fragment, null, children);
        }
        actualSteps = res;
    }
    else {
        actualSteps = steps;
    }
    const index = obj.get(progressKey) || 0;
    if (actualSteps.length === 0 || index >= actualSteps.length) {
        obj.set(doneKey, true);
        return React.createElement(React.Fragment, null, children);
    }
    const Step = actualSteps[index];
    const next = () => {
        if (index + 1 >= actualSteps.length) {
            obj.set(doneKey, true);
        }
        else {
            obj.set(progressKey, index + 1);
        }
    };
    return React.createElement(Step, { next: next });
};
